import { useEffect, useState } from 'react';

function useDetectSmallScreenUsingUserAgent() {
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    const ua = navigator?.userAgent;
    const value = /Tablet|iPad|Android(?!.*Mobile)/i.test(ua);
    setIsTablet(value);
  }, []);

  return isTablet;
}
export default useDetectSmallScreenUsingUserAgent;
